import type { PersonalDatasetItem } from '@dmp/api/api.types';
import { type StateCreator } from 'zustand';

export type OwnDatasetsState = {
  ownDatasets: PersonalDatasetItem[];
  isFetchingOwnDatasets: boolean;
  totalOwnDatasetsCount: number;
  ownDatasetsPage: number;
  ownDatasetsPageSize: number;
};

export const initialOwnDatasetsState: OwnDatasetsState = {
  ownDatasets: [],
  isFetchingOwnDatasets: false,
  totalOwnDatasetsCount: 0,
  ownDatasetsPage: 1,
  ownDatasetsPageSize: 12,
};

export const createOwnDatasetsSlice: StateCreator<OwnDatasetsState> = () => initialOwnDatasetsState;
